import React from 'react'
import Footer from '../Components/Footer/Footer'
import Login from '../Components/Login/Login'
import Header from '../Components/Header/Header'

const LoginPage = () => {
  return (
    <>
    <Header minimal/>
    <Login/>
    <Footer/>
    </>
  )
}

export default LoginPage
